export default __webpack_public_path__ + "static/media/home-activities-lectures.b3465fc8.png";